// Test IDs for Mach3 NFS Wizard Web
export const IDS = {
  topbar: {
    projectName: 'topbar-project-name',
    save: 'topbar-save-project-button',
    wcs: 'topbar-wcs-select',
    units: 'topbar-units-select',
    settings: 'topbar-settings-button',
    importDxf: 'topbar-import-dxf-button',
    importGcode: 'topbar-import-gcode-button',
    tools: 'topbar-tools-button',
    projects: 'topbar-projects-button',
    feedspeed: 'topbar-feedspeed-button',
  },
  left: {
    operationList: 'left-operation-list',
    operationItem: (id) => `left-operation-${id}`,
    parameterForm: 'left-parameter-form',
    generate: 'left-generate-gcode-button',
  },
  viewport: {
    viewport: 'center-3d-viewport',
    play: 'viewport-play-button',
    pause: 'viewport-pause-button',
    reset: 'viewport-reset-button',
    scrubber: 'viewport-scrubber-slider',
    viewPreset: 'viewport-view-preset-select',
    toggleGrid: 'viewport-toggle-grid-button',
    toggleStock: 'viewport-toggle-stock-button',
  },
  right: {
    gcodeEditor: 'right-gcode-editor',
    download: 'right-download-gcode-button',
    import: 'right-import-gcode-button',
    copy: 'right-copy-gcode-button',
    validation: 'right-validation-panel',
  },
  tools: {
    open: 'tools-open-button',
    add: 'tools-add-button',
    table: 'tools-table',
    save: 'tools-save-button',
    delete: 'tools-delete-button',
  },
  projects: {
    open: 'projects-open-button',
    list: 'projects-list',
    load: 'projects-load-button',
    delete: 'projects-delete-button',
    save: 'projects-save-button',
  },
  fs: {
    open: 'feedspeed-open-button',
    material: 'feedspeed-material-select',
    result: 'feedspeed-result-panel',
    apply: 'feedspeed-apply-button',
  },
  dxf: {
    file: 'dxf-file-input',
    import: 'dxf-import-confirm-button',
  },
};
